import React from 'react';

const AssignTaskStatusCategory = React.lazy(() => import('pages/AssignTaskStatus/AssignTaskStatusCategory'));
const AssignTaskStatusCategoryAdd = React.lazy(() => import('pages/AssignTaskStatus/AssignTaskStatusCategoryAdd'));
const AssignTaskStatusCategoryEdit = React.lazy(() => import('pages/AssignTaskStatus/AssignTaskStatusCategoryEdit'));
const AssignTaskStatusCategoryDetail = React.lazy(
  () => import('pages/AssignTaskStatus/AssignTaskStatusCategoryDetail'),
);

const assignTaskStatusRoutes = [
  {
    path: '/assign-task-status-category',
    exact: true,
    name: 'Danh sách trạng thái',
    function: 'ASSIGN_TASK_STATUS_VIEW',
    component: AssignTaskStatusCategory,
  },
  {
    path: '/assign-task-status-category/add',
    exact: true,
    name: 'Thêm mới trạng thái',
    function: 'ASSIGN_TASK_STATUS_ADD',
    component: AssignTaskStatusCategoryAdd,
  },
  {
    path: '/assign-task-status-category/detail/:id',
    exact: true,
    name: 'Chi tiết trạng thái',
    function: 'ASSIGN_TASK_STATUS_VIEW',
    component: AssignTaskStatusCategoryDetail,
  },
  {
    path: '/assign-task-status-category/edit/:id',
    exact: true,
    name: 'Chỉnh sửa trạng thái',
    function: 'ASSIGN_TASK_STATUS_EDIT',
    component: AssignTaskStatusCategoryEdit,
  },
];

export default assignTaskStatusRoutes;
